import { render } from "./UiDropDown.vue?vue&type=template&id=0169d8fb&scoped=true"
import script from "./UiDropDown.vue?vue&type=script&lang=js"
export * from "./UiDropDown.vue?vue&type=script&lang=js"

import "./UiDropDown.vue?vue&type=style&index=0&id=0169d8fb&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0169d8fb"]])

export default __exports__